import * as XLSX from "xlsx";
import moment from "moment";
import { PhoneNumber } from "../../utils/phoneNumber";


const employeesExcelReport = async (employees: any) => {
    if (employees.length === 0 || !employees) return

    const headers = [
        "Apellido",
        "Nombre",
        "DNI",
        "CUIL",
        "Nacionalidad",
        "Fecha de nacimiento",
        "Estado Civil",
        "Sexo",
        "Género",
        "Email",
        "Teléfono",
        "Dirección",
        "Dirección:Información complementaria",
        "Ciudad",
        "Provincia",
        "Código Postal",
        "Puesto",
        "Fecha de creación del empleado"
    ];

    const excelDataPromises = employees?.map((employee: any) => {
        const lastname = employee?.name?.split(',')[0].toUpperCase();
        const name = employee?.name?.split(',')[1].toUpperCase();
        const dni = employee?.DNI ? employee?.DNI : '---';
        const cuil = employee?.cuil ? employee?.cuil : '---';
        const nacionalidad = employee?.nationality ? employee?.nationality.toUpperCase() : '---';
        const fechaNacimiento = employee?.birthDate;
        const estadoCivil = employee?.maritalStatus ? employee.maritalStatus.toUpperCase() : '---';
        const sexo = employee?.sex ? employee?.sex : '---';
        const genero = employee?.genre ? employee?.genre : '---';
        const email = employee?.email ? employee?.email : '---';
        const tel = employee?.phoneNumber ? PhoneNumber(employee?.phoneNumber) : '---';
        const direccion = employee?.fullAddress ? employee?.fullAddress : '---';
        const infoComplementaria = employee?.supplementaryReference ? employee?.supplementaryReference : '---';
        const ciudad = employee?.city ? employee?.city.toUpperCase() : '---';
        const provincia = employee?.province ? employee?.province.toUpperCase() : '---';
        const cp = employee?.postalCode ? employee?.postalCode.toUpperCase() : '---';
        const posicion = employee?.positionName ? employee?.positionName.toUpperCase() : '---';
        const fechaCreacionEmpleado = moment(employee?.employeeCreatedDate).format('DD/MM/YYYY')



        return [
            lastname,
            name,
            dni,
            cuil,
            nacionalidad,
            fechaNacimiento,
            estadoCivil,
            sexo,
            genero,
            email,
            tel,
            direccion,
            infoComplementaria,
            ciudad,
            provincia,
            cp,
            posicion,
            fechaCreacionEmpleado,
        ]
    })



    const excelData = await Promise.all(excelDataPromises);
    const ws = XLSX.utils.aoa_to_sheet([headers, ...excelData]);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Sheet1");
    const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    const blob = new Blob([excelBuffer], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    const date = moment().format('DD/MM/YYYY')
    let filename = `Reportes-todos-Empleados-${date}.xlsx`;

    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = filename;
    link.click();

    return excelDataPromises;

}
export default employeesExcelReport;